import './global-cursor.css';

let lastCursorSource: string | undefined;

/**
 * Applies a cursor globally.
 *
 * This is useful e.g. for drag&drop interactions.
 *
 * @param cursor - A CSS cursor keyword (see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor|docs in the MDN})
 * @param cursorSourceId - source of global cursor which should match the last source in-order to override the global cursor.
 * Should be unique per logic that manages the drag/resize interaction
 */
export function applyGlobalCursor(cursor: string, cursorSourceId: string) {
  if (!lastCursorSource || cursorSourceId === lastCursorSource) {
    const root = document.documentElement;
    root.style.cursor = cursor;
    const hasCursor = Boolean(cursor);
    root.classList.toggle('has-global-cursor', hasCursor);
    lastCursorSource = hasCursor ? cursorSourceId : undefined;
  }
}
